/* eslint-disable */

import Vue from 'vue';
import Portal from 'portal-vue';

// Application styles
import 'animate.css';
import '@/styles/main.scss';

import 'vue-slider-component/theme/default.css';
import '@fortawesome/fontawesome-free/js/all';

// FontAwesomeIcon
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Plugins
import { ToastPlugin } from '@/plugins/toast';

import VueSocialSharing from 'vue-social-sharing'

import 'jquery';
import 'vanilla-lazyload';
import './vendors/common_scripts.min';
import './vendors/script';
import './vendors/Chart';
import './vendors/chart-function';

// Internationalization
import { i18n } from '@/i18n';

import FileSelector from 'vue-file-selector';
import QrcodeVue from 'qrcode.vue';

// Shared components
import StarRating from 'vue-star-rating';
import VueSlider from 'vue-slider-component';
import { Divider } from '@/components/shared/divider';
import { Skeleton } from '@/components/shared/skeleton';
import { SkeletonItem } from '@/components/shared/skeleton-item';
import { Toast } from '@/components/shared/toast';
import { ConfirmModal } from '@/components/shared/confirm-modal';
import { Modal } from '@/components/shared/modal';
import { Icon } from '@/components/shared/icon';

// Router and Store
import { router } from './router';
import { store } from './store';

// Default import
import App from './App.vue';
import VueCalendly from 'vue-calendly';
import Zendesk from '@dansmaculotte/vue-zendesk';

Vue.config.productionTip = false;

Vue.use(Zendesk, {
  key: '4591939b-c8e2-4d8c-b9db-bb9e1b531846',
  disabled: true,
  hideOnLoad: true,
  settings: {
    webWidget: {
      color: {
        theme: '#78a300'
      }
    }
  }
});

Vue.use(VueSocialSharing);

Vue.use(Portal);
Vue.use(ToastPlugin);
Vue.use(FileSelector);

Vue.component('el-vue-slider', VueSlider);
Vue.component('el-confirm-modal', ConfirmModal);
Vue.component('el-divider', Divider);
Vue.component('el-modal', Modal);
Vue.component('el-skeleton', Skeleton);
Vue.component('el-skeleton-item', SkeletonItem);
Vue.component('el-toast', Toast);
Vue.component('el-icon', Icon);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('qr-code', QrcodeVue);



export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
